import { Component, Input, OnInit } from '@angular/core';
import { TableColumn } from 'app/component-library/table/table-column';
import { TableConfig } from 'app/component-library/table/table-config';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { TableSelectionMode } from '../../../component-library/table/table-selection-mode';
import { ChildDataTableItem } from '../../../viewmodels/child-data-table-item';
import { ChildDataTableService } from '../child-data-table.service';
import { ChildTableMultiSelectionConfig } from '../child-table-config';
import { ChildTableData } from '../child-table-data';
@Component({
  selector: 'hb-child-data-table-multi-selection-dialog',
  templateUrl: './child-data-table-multi-selection-dialog.component.html',
  styleUrls: ['./child-data-table-multi-selection-dialog.component.scss'],
})
export class ChildDataTableMultiSelectionDialogComponent<T extends ChildDataTableItem> implements OnInit {
  private childDataTableService: ChildDataTableService;
  tableConfig: TableConfig;
  _config: ChildTableMultiSelectionConfig<T>;

  get config(): ChildTableMultiSelectionConfig<T> {
    return this._config;
  }

  @Input() set config(value: ChildTableMultiSelectionConfig<T>) {
    this._config = value;
    this.initTableConfig();
  }

  selectedItems: T[] = [];
  data: ChildTableData<T>;

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit() {
  }

  submitClick() {
    if (this.selectedItems.length === 0) {
      return;
    }

    this.childDataTableService.acceptAddedStrategies(this.selectedItems);
  }

  setService(service: ChildDataTableService) {
    this.childDataTableService = service;

    this.data = this.childDataTableService.data;
  }

  private initTableConfig(): void {
    this.tableConfig = new TableConfig();
    this.tableConfig.id = 'child-data-table-multi-selection-dialog-table';
    this.tableConfig.showHeader = false;
    this.tableConfig.enableEdit = false;
    this.tableConfig.enableAdd = false;
    this.tableConfig.enableDelete = false;
    this.tableConfig.enableFiltering = false;
    this.tableConfig.enableSorting = true;
    this.tableConfig.enablePagination = true;
    this.tableConfig.rowsPerPage = 20;
    this.tableConfig.enableSelectionColumn = true;
    this.tableConfig.selectionMode = TableSelectionMode.Multiple;
    this.tableConfig.dataKey = this.config.dataKey;
    this.tableConfig.startingSortOrder = 1;
    this.tableConfig.startingSortField = this.config.sortField;
    this.tableConfig.emptyMessage = 'No ' + this.config.itemTypeName.toLowerCase() + ' items are available';
    this.tableConfig.columns = [];

    this.config.selectionColumns.forEach(col => {
      this.tableConfig.columns.push(new TableColumn(col.header, col.field, '', col.sortable))
    });
  }

  public onSelectionChange($event: any): void {
    this.selectedItems = $event;
  }
}
